import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import VehiclesPage from "@/pages/VehiclesPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import ReservationPage from "@/pages/ReservationPage";
import AdminApp from "@/pages/admin/AdminApp";
import ConfirmationMariage from "@/pages/ConfirmationMariage";
import TrackingScripts from "@/components/TrackingScripts";
import PaymentPage, { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPage";
import DisponibilitesPage from "@/pages/DisponibilitesPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getOrCreateSession() {
  let sid = sessionStorage.getItem("rm_sid");
  if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("rm_sid", sid); }
  return sid;
}
function getDevice() {
  const ua = navigator.userAgent;
  if (/Mobi|Android/i.test(ua)) return "mobile";
  if (/Tablet|iPad/i.test(ua)) return "tablet";
  return "desktop";
}

function PageTracker() {
  const location = useLocation();
  const lastTracked = useRef("");
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return; // Ne pas tracker les pages admin
    if (path === lastTracked.current) return;
    lastTracked.current = path;
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page: path,
        session_id: getOrCreateSession(),
        referrer: document.referrer || "",
        device: getDevice(),
      }),
    }).catch(() => {}); // Fire and forget
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TrackingScripts />
        <PageTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vehicules" element={<VehiclesPage />} />
          <Route path="/vehicules/:id" element={<VehicleDetailPage />} />
          <Route path="/reservation" element={<ReservationPage />} />
          <Route path="/reservation/:vehicleId" element={<ReservationPage />} />
          <Route path="/confirmation/:token" element={<ConfirmationMariage />} />
          <Route path="/paiement" element={<PaymentPage />} />
          <Route path="/paiement/success" element={<PaymentSuccessPage />} />
          <Route path="/paiement/cancel" element={<PaymentCancelPage />} />
          <Route path="/disponibilites" element={<DisponibilitesPage />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
